function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "chat_bot");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M225.34214,665.935a4.77664,4.77664,0,0,0-2.81646.99092c-2.40045-6.34374-6.11652-10.42042-10.29133-10.42042s-7.89087,4.07668-10.29132,10.42042a4.77669,4.77669,0,0,0-2.81646-.99092c-4.74294,0-8.58786,8.02128-8.58786,17.916H233.93C233.93,673.95626,230.08508,665.935,225.34214,665.935Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#6c63ff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  y: 479.97356,
  width: 220,
  height: 2,
  fill: "#3f3d56"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1007.34214,623.909a4.77664,4.77664,0,0,0-2.81646.99092c-2.40045-6.34374-6.11652-10.42042-10.29133-10.42042s-7.89087,4.07668-10.29132,10.42042a4.77669,4.77669,0,0,0-2.81646-.99092c-4.74294,0-8.58786,8.02128-8.58786,17.916H1015.93C1015.93,631.93026,1012.08508,623.909,1007.34214,623.909Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#6c63ff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M913.97887,294.73032H704.48915v-4.31776H609.49836v4.31776H399.14509a14.17039,14.17039,0,0,0-14.1704,14.1704V595.75656a14.17044,14.17044,0,0,0,14.1704,14.17046H913.97887a14.17044,14.17044,0,0,0,14.1704-14.17046V308.90072A14.17039,14.17039,0,0,0,913.97887,294.73032Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#3f3d56"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 226.22703,
  y: 116.89232,
  width: 505.16998,
  height: 284.98004,
  opacity: 0.2
});

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 478.38008,
  cy: 103.94303,
  r: 5.18132,
  fill: "#6c63ff"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 111.50024,
  y: 436.948,
  width: 732.99951,
  height: 2,
  fill: "#3f3d56"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M725.58249,426.24265V405.15879a25.86891,25.86891,0,0,0-25.86893-25.86893H678.6297c0-2.846-9.14594-5.17779-20.76758-5.39878V348.46519a14.447,14.447,0,1,0-3.61175,0v25.42589c-11.62164.221-20.76758,2.55274-20.76758,5.39878H608.78717a25.86891,25.86891,0,0,0-25.86893,25.86893v21.08386c-2.99209,0-5.41763,10.10647-5.41763,22.57346s2.42554,22.57346,5.41763,22.57346v24.69561a25.86891,25.86891,0,0,0,25.86893,25.86893h90.92639a25.86891,25.86891,0,0,0,25.86893-25.86893V471.38957c2.99209,0,5.41763-10.10648,5.41763-22.57346S728.57458,426.24265,725.58249,426.24265Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#6c63ff"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M436.21643,184.53924h80.56769a22.92181,22.92181,0,0,1,22.92181,22.92181V288.0288a22.92181,22.92181,0,0,1-22.92181,22.92181H436.21637a22.92181,22.92181,0,0,1-22.92181-22.92181V207.46111A22.92188,22.92188,0,0,1,436.21643,184.53924Z",
  fill: "#3f3d56"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M625.35634,447.4617a16.27123,16.27123,0,0,1-16.25289-16.25289.90294.90294,0,1,1,1.80588,0,14.447,14.447,0,1,0,28.894,0,.90294.90294,0,0,1,1.80588,0A16.27123,16.27123,0,0,1,625.35634,447.4617Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#6c63ff"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M654.25037,478.1616a12.65534,12.65534,0,0,1-12.64114-12.64113.90294.90294,0,0,1,1.80588,0,10.83526,10.83526,0,0,0,21.67052,0,.90293.90293,0,1,1,1.80587,0A12.65533,12.65533,0,0,1,654.25037,478.1616Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#6c63ff"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.14439,447.4617a16.27123,16.27123,0,0,1-16.25289-16.25289.90294.90294,0,1,1,1.80588,0,14.447,14.447,0,1,0,28.894,0,.90294.90294,0,0,1,1.80588,0A16.27151,16.27151,0,0,1,683.14439,447.4617Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#6c63ff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 447.60622,
  cy: 229.23473,
  r: 8.12644,
  fill: "#6c63ff"
});

var _ref16 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 505.39427,
  cy: 229.23473,
  r: 8.12644,
  fill: "#6c63ff"
});

var _ref17 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 476.50024,
  cy: 267.15814,
  rx: 7.22351,
  ry: 3.61175,
  fill: "#6c63ff"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M942.33358,599.56437H893.03147v-3.55219a.70429.70429,0,0,0-.70432-.70431H875.42357a.70429.70429,0,0,0-.70432.70431v3.55219H864.15451v-3.55219a.70429.70429,0,0,0-.70431-.70431H846.54661a.70428.70428,0,0,0-.70431.70431v3.55219H835.27756v-3.55219a.70429.70429,0,0,0-.70432-.70431H817.66966a.70429.70429,0,0,0-.70432.70431v3.55219H806.4006v-3.55219a.70428.70428,0,0,0-.70431-.70431H788.79271a.70429.70429,0,0,0-.70432.70431v3.55219H777.52365v-3.55219a.70429.70429,0,0,0-.70432-.70431H759.91575a.70428.70428,0,0,0-.70431.70431v3.55219H748.6467v-3.55219a.70429.70429,0,0,0-.70432-.70431H731.0388a.70429.70429,0,0,0-.70432.70431v3.55219H719.76974v-3.55219a.70428.70428,0,0,0-.70431-.70431H586.654a.70429.70429,0,0,0-.70432.70431v3.55219H575.385v-3.55219a.70428.70428,0,0,0-.70431-.70431H557.77707a.70429.70429,0,0,0-.70431.70431v3.55219H546.508v-3.55219a.70429.70429,0,0,0-.70432-.70431H528.90012a.70429.70429,0,0,0-.70432.70431v3.55219H517.63107v-3.55219a.70429.70429,0,0,0-.70432-.70431H500.02317a.70429.70429,0,0,0-.70432.70431v3.55219H488.75411v-3.55219a.70429.70429,0,0,0-.70431-.70431H471.14621a.70428.70428,0,0,0-.70431.70431v3.55219H459.87716v-3.55219a.70429.70429,0,0,0-.70432-.70431H442.26926a.70429.70429,0,0,0-.70432.70431v3.55219H431.0002v-3.55219a.70428.70428,0,0,0-.70431-.70431H413.39231a.70429.70429,0,0,0-.70432.70431v3.55219H380.28946A16.90359,16.90359,0,0,0,363.38587,616.468v7.6434a16.90359,16.90359,0,0,0,16.90359,16.90354H942.33358a16.90358,16.90358,0,0,0,16.90358-16.90354V616.468A16.90359,16.90359,0,0,0,942.33358,599.56437Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#3f3d56"
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 303.50024,
  y: 317.948,
  width: 337,
  height: 2,
  fill: "#6c63ff"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M505.25037,519.825h-83a555.42428,555.42428,0,0,0,0-94h83C500.68054,458.01945,500.41327,489.40312,505.25037,519.825Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#d0cde1"
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 256.50024,
  y: 241.948,
  width: 60,
  height: 4,
  fill: "#3f3d56"
});

var _ref22 =
/*#__PURE__*/
React.createElement("rect", {
  x: 256.50024,
  y: 254.948,
  width: 60,
  height: 4,
  fill: "#3f3d56"
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 256.50024,
  y: 267.948,
  width: 60,
  height: 4,
  fill: "#3f3d56"
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 256.50024,
  y: 280.948,
  width: 60,
  height: 4,
  fill: "#3f3d56"
});

var _ref25 =
/*#__PURE__*/
React.createElement("rect", {
  x: 256.50024,
  y: 293.948,
  width: 60,
  height: 4,
  fill: "#3f3d56"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M284.69436,206.08439s-13.04116-4.65756-21.42475,13.97266-21.42476,39.12346-21.42476,39.12346l7.45209,1.863s1.863-13.04115,6.52058-14.90417l-1.863,16.76719s55.89065,19.56173,81.04145-1.863l-.93151-6.52058s3.726.93151,3.726,6.52058L340.585,258.249s-2.79453-5.58907-11.17813-13.04116c-5.50263-4.89122-7.39357-14.19672-8.04338-20.01467a24.2202,24.2202,0,0,0-5.57613-13.18957C310.216,205.54675,300.06429,198.68405,284.69436,206.08439Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#2f2e41"
});

var _ref27 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "69.335 414.136 73.335 437.136 89.335 434.136 92.335 414.136 69.335 414.136",
  fill: "#ffb9b9"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M270.085,630.01324l-22,2,1,18-1,23s-13,26,6,24,17-12,17-12l5-6-3-15Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#2f2e41"
});

var _ref29 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "159.335 414.136 155.335 437.136 139.335 434.136 136.335 414.136 159.335 414.136",
  fill: "#ffb9b9"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M314.085,630.01324l22,2-1,18,1,23s13,26-6,24-17-12-17-12l-5-6,3-15Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#2f2e41"
});

var _ref31 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 113.33489,
  cy: 42.13622,
  r: 23,
  fill: "#ffb9b9"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M276.085,257.01324l3,36,28-1s-8-23-3-32Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#ffb9b9"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M292.085,286.01324l11.51772-7.18371,12.48228,6.18371,20,9-7,85s16,53,13,79,33,156,4,162-50,12-51,2-3-163-3-163-3,162-15,164-64,10-60-2,31-222,44-234l2-10-17-81,31.92411-15.91067Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#2f2e41"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M232.085,410.01324l-1,41s-9.626,40.47857,6.687,40.23929,4.313-40.23929,4.313-40.23929l7-40Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#ffb9b9"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M383.29816,366.98218l28.10344,29.86966s34.18015,23.72533,21.87052,34.4325S403.20877,404.192,403.20877,404.192l-31.905-25.12114Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#ffb9b9"
});

var _ref36 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "83.835 181.636 152.325 179.536 151.435 174.886 151.435 174.866 85.235 173.666 83.835 181.636",
  fill: "#d0cde1"
});

var _ref37 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 97.83489,
  cy: 177.63622,
  r: 6,
  fill: "#2f2e41"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M254.085,297.01324l-6.5-1.5s-8.5,3.5-10.5,14.5-28,97-15,102,32,7,32,5,8-77,8-77Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#2f2e41"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M315.25037,300.825l20.83464-6.81178s10,0,10,11c0,4.53782,19.16536,41.81178,19.16536,41.81178s46.04964,32.82506,39,34c-12,2-19,23-19,23l-45-40Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#2f2e41"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M263.0337,246.72609s7.45209-10.24662,13.97267-12.10965,7.45208-11.17813,7.45208-11.17813S301.22565,242.06853,311.47227,243s.93151-22.35626.93151-22.35626l-18.63022-4.65755-17.6987,1.863-13.97267,9.31511Z",
  transform: "translate(-177.75012 -202.87702)",
  fill: "#2f2e41"
});

var _ref41 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 90.83489,
  cy: 38.63622,
  rx: 3,
  ry: 4.5,
  fill: "#ffb9b9"
});

var SvgUndrawChatBotKli5 = function SvgUndrawChatBotKli5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "e9b383de-0ed4-41c7-955a-d31167ca9f18",
    "data-name": "Layer 1",
    width: 844.49976,
    height: 494.24596,
    viewBox: "0 0 844.49976 494.24596",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndrawChatBotKli5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undraw_chat_bot_kli5.f3bdf9ef.svg";
export { ForwardRef as ReactComponent };